// src/theme/atomic/neutral.ts
var neutral = {
  5: "#0F0F0F",
  10: "#171717",
  15: "#1C1C1C",
  20: "#2A2A2A",
  22: "#303030",
  30: "#474747",
  40: "#5C5C5C",
  50: "#737373",
  60: "#8A8A8A",
  70: "#9B9B9B",
  80: "#B0B0B0",
  90: "#C4C4C4",
  95: "#DCDCDC",
  99: "#F7F7F7"
};
var neutral_default = neutral;

export { neutral_default as default };
